(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kit-configurator"] && !Shopify.designMode) return;
  try {
    
(function () {
  var BASE = 7495;
  var PRICES = { target: 945, player: 579, lane: 1449 };
  var TARGETS = { target: 5, player: 0, lane: 5 };
  var PLAYERS = { target: 0, player: 1, lane: 1 };
  var qtys = { target: 0, player: 0, lane: 0 };
  var installDays = 0;

  function fmt(n) {
    return '$' + n.toLocaleString('en-US');
  }

  function update() {
    var total = BASE;
    var targets = 10;
    var players = 1;
    ['target', 'player', 'lane'].forEach(function (key) {
      var q = qtys[key];
      var sub = q * PRICES[key];
      total += sub;
      targets += q * TARGETS[key];
      players += q * PLAYERS[key];
      document.getElementById('qty-' + key).textContent = q;
      document.getElementById('price-' + key).textContent = q > 0 ? fmt(sub) : '\u2014';
    });
    var installCost = installDays * 1000;
    total += installCost;
    document.getElementById('price-install').textContent = installDays > 0 ? fmt(installCost) + ' est.' : '\u2014';
    document.getElementById('running-total').textContent = fmt(total);
    document.getElementById('total-targets').textContent = targets;
    document.getElementById('total-players').textContent = players;
  }

  document.querySelectorAll('.kit-qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var row = btn.dataset.row;
      if (btn.dataset.action === 'plus') {
        qtys[row]++;
      } else if (qtys[row] > 0) {
        qtys[row]--;
      }
      update();
    });
  });

  var installToggle = document.getElementById('install-toggle');
  var installDaysWrap = document.getElementById('install-days-wrap');
  var installDaysSelect = document.getElementById('install-days');

  installToggle.addEventListener('change', function () {
    if (installToggle.checked) {
      installDaysWrap.style.display = '';
      installDays = parseInt(installDaysSelect.value, 10);
    } else {
      installDaysWrap.style.display = 'none';
      installDays = 0;
    }
    update();
  });

  installDaysSelect.addEventListener('change', function () {
    installDays = parseInt(installDaysSelect.value, 10);
    update();
  });

  function buildSummary() {
    var lines = ['NEATO Gallery Kit (base)  \u2014  $7,495'];
    if (qtys.target > 0) lines.push('+5 Target Expansion \xd7' + qtys.target + '  \u2014  ' + fmt(qtys.target * PRICES.target));
    if (qtys.player > 0) lines.push('+1 Player Expansion \xd7' + qtys.player + '  \u2014  ' + fmt(qtys.player * PRICES.player));
    if (qtys.lane > 0) lines.push('+1 Lane Expansion \xd7' + qtys.lane + '  \u2014  ' + fmt(qtys.lane * PRICES.lane));
    if (installDays > 0) lines.push('On-Site Installation: ' + installDays + ' days  \u2014  ' + fmt(installDays * 1000) + ' est. (travel billed separately)');
    var total = BASE + qtys.target * PRICES.target + qtys.player * PRICES.player + qtys.lane * PRICES.lane + installDays * 1000;
    lines.push('');
    lines.push('Targets: ' + (10 + qtys.target * 5 + qtys.lane * 5) + '   Players: ' + (1 + qtys.player + qtys.lane));
    lines.push('Estimated Total: ' + fmt(total));
    return lines.join('\n');
  }

  var modal = document.getElementById('quote-modal');
  var openBtn = document.getElementById('open-quote-modal');
  var closeBtn = document.getElementById('close-quote-modal');

  openBtn.addEventListener('click', function () {
    var summary = buildSummary();
    document.getElementById('modal-config-summary').innerHTML = '<pre>' + summary + '</pre>';
    document.getElementById('quote-body').value = 'Gallery Kit Quote Request\n\n' + summary;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  });

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closeModal);
  modal.querySelector('.kit-modal__backdrop').addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  document.getElementById('quote-form').addEventListener('submit', function () {
    var notes = document.getElementById('quote-notes').value;
    document.getElementById('quote-body').value = 'Gallery Kit Quote Request\n\n' + buildSummary() + (notes ? '\n\nNotes: ' + notes : '');
  });
})();

  } catch(e) { console.error(e); }
})();
})();
